<template>
  <div class="hero-shape" :class="{'is-open': isOpen}" :style="computedStyle">
    <div class="hero-shape__left"></div>
    <div class="hero-shape__background"></div>
    <div class="hero-shape__right"></div>
    <div class="hero-shape__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>

  export default {
    name: "HeroShape",
    props: {
      isOpen: {
        type: Boolean,
        default: false,
      },
      heroMdWidth: {
        type: String,
        default: "50%"
      },
      heroLgWidth: {
        type: String,
        default: "50%"
      },
      heroXlWidth: {
        type: String,
        default: "50%"
      }
    },
    computed: {
      computedStyle() {
        return {
          '--hero-md-width': this.heroMdWidth,
          '--hero-lg-width': this.heroLgWidth,
          '--hero-xl-width': this.heroXlWidth,
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@rawlplug/rawlplug-design-style-tokens/dist/scss/all";

  $hero-shape-background-color: rgba(0, 23, 45, 0.99) !default;
  $opacity: 0.9;

  .hero-shape {
    font-size: $font-size-rwl-body;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;

    &__background {
      background-color: $hero-shape-background-color;
      border-radius: 0px 0px 100px 100px;
      height: calc(100% - 60px);
      opacity: $opacity;
      width: 100%;
      transition: transform 0.4s;
    }

    &__content {
      width: 100%;
      height: calc(100% - 60px);
      position: absolute;
      padding: $spacing-4;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    &__left, &__right {
      width: 90px;
      height: 90px;
      overflow: hidden;
      position: absolute;
      transition: transform 400ms ease-in-out, opacity 100ms ease-in-out;
      opacity: $opacity;

      &:before {
        position: absolute;
        padding: 90px;
        content: '';
        border-radius: 50%;
        box-shadow: 0 0 0 300px #00172d;
      }
    }

    &__left {
      position: absolute;
      top: 0;
      left: 0;
      transform: translateX(-100%);

      &:before {
        margin: -90px;
        top: 90px
      }
    }

    &__right {
      top: 0;
      right: -90px;
    }

    &.is-open {
      .hero-shape__background {
        transform: scale(80);
      }

      .hero-shape__left {
        transform: translateX(-2000px);
        opacity: 0;
      }

      .hero-shape__right {
        transform: translateX(2000px);
        opacity: 0;
      }
    }
  }

  @media (min-width: $breakpoint-sm-min) {
    .hero-shape {
      width: var(--hero-sm-width);

      &__content {
        padding: $spacing-4;
      }
    }
  }

  @media (min-width: $breakpoint-md-min) {
    .hero-shape {
      width: var(--hero-md-width);

      &__content {
        padding: $spacing-7;
      }
    }
  }

  @media (min-width: $breakpoint-lg-min) {
    .hero-shape {
      width: var(--hero-lg-width);
    }
  }

  @media (min-width: $breakpoint-xl-min) {
    .hero-shape {
      width: var(--hero-xl-width);
    }
  }
</style>
